import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const FillAdvancedLinkedin = ({ fill = 'currentColor' }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask
      id="mask0_30611_11634"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <path d="M24 0H0V24H24V0Z" fill="white" />
    </mask>
    <g mask="url(#mask0_30611_11634)">
      <path
        d="M17 2H7C4.24 2 2 4.24 2 7V17C2 19.76 4.24 22 7 22H17C19.76 22 22 19.77 22 17.01V7C22 4.24 19.76 2 17 2ZM8.44 17C8.44 17.41 8.1 17.75 7.69 17.75C7.28 17.75 6.94 17.41 6.94 17V11C6.94 10.59 7.28 10.25 7.69 10.25C8.1 10.25 8.44 10.59 8.44 11V17ZM7.69 8.63C7.14 8.63 6.69 8.18 6.69 7.63C6.69 7.08 7.14 6.63 7.69 6.63C8.24 6.63 8.69 7.08 8.69 7.63C8.69 8.18 8.24 8.63 7.69 8.63ZM17.44 17C17.44 17.41 17.1 17.75 16.69 17.75C16.28 17.75 15.94 17.41 15.94 17V13.5C15.94 12.54 15.15 11.75 14.19 11.75C13.23 11.75 12.44 12.54 12.44 13.5V17C12.44 17.41 12.1 17.75 11.69 17.75C11.28 17.75 10.94 17.41 10.94 17V13.5C10.94 11.71 12.4 10.25 14.19 10.25C15.98 10.25 17.44 11.71 17.44 13.5V17Z"
        fill={fill}
      />
    </g>
  </svg>
)

export default withDefaultStyles(FillAdvancedLinkedin)
